module.exports = __webpack_public_path__ + "static/img/ent-50.f843658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-50.jpg
// module id = wP8/
// module chunks = 51